import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './TablePagination.module.scss';
import PaginationButtons from '../PaginationButtons/PaginationButtons';

export interface TablePaginationProps {
  maxPage: number;
  currentPage: number;
  onPaginationClick: (direction: 'previous' | 'next') => void;
}

const TablePagination: React.FC<TablePaginationProps> = ({ maxPage, currentPage = 1, onPaginationClick }) => {
  const { t } = useTranslation();
  const max = maxPage > 0 ? maxPage : 1; // needed because pagination does not work if BE sends maxPage = 0
  return (
    <div className={classNames(styles.root, 'flex typo-text-12 text-faded items-center gap-x-16')}>
      <span className="flex items-center">
        <strong>
          {t('general.page')} {currentPage + 1} {t('general.of')} {max}
        </strong>
      </span>
      <PaginationButtons
        onClick={onPaginationClick}
        disabledPrevious={currentPage === 0}
        disabledNext={currentPage + 1 === max}
      />
    </div>
  );
};

export default TablePagination;
